var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElem2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 355.78 355.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5db77f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_6944-2",
    "data-name": "Path 6944-2",
    className: "cls-1",
    d: "m355.78,355.77h-52.18C135.92,355.77,0,219.85,0,52.19V0h44.87c171.71,0,310.9,139.19,310.9,310.9v44.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6944-3",
    "data-name": "Path 6944-3",
    className: "cls-1",
    d: "m355.78,355.77h-52.18C135.92,355.77,0,219.85,0,52.19V0h44.87c171.71,0,310.9,139.19,310.9,310.9v44.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElem2);
export default __webpack_public_path__ + "static/media/elem2.718efe4656fc2a3fa3afdc96d0216b95.svg";
export { ForwardRef as ReactComponent };